import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link as BaseLink } from 'react-router-dom';
import { Link } from '@material-ui/core';

import { ROUTES } from '../../core/router/routes';
import './mostSearched.scss';
import { useGetMostSearchedArticlesQuery } from '../../features/article/api/articleApi';

const MostSearched: FC = () => {
  const { t } = useTranslation();
  const { data: mostSearchedArticles, isSuccess } = useGetMostSearchedArticlesQuery();

  return (
    <section className="MostSearched-Section">
      <h3>{t('most_searched.title')}</h3>
      <ul>
        {isSuccess &&
          mostSearchedArticles.map(({ title, id }) => {
            return (
              <li key={id}>
                <Link to={ROUTES.ARTICLE.SHOW.replace(':id', id as unknown as string)} component={BaseLink}>
                  {title}
                </Link>
              </li>
            );
          })}
      </ul>
    </section>
  );
};

export default MostSearched;
